import { getQaSelector } from '../../../utils/common'
import { FloatingSelectDropdown, FloatingTooltip } from '../../Floating'
import { SelectContextProvider } from '../SelectContextProvider'
import { SelectDropdownList } from '../SelectDropdownList'
import { SelectFocusContextProvider } from '../SelectFocusContextProvider'

import {
  QA_NAME_SELECT_CONTEXT,
  QA_NAME_SELECT_DROPDOWN_CONTEXT,
} from './Select.constants'

import * as styles from './Select.module.css'

/*
 * Base component for composing select.
 */
function Select({
  Control,
  Dropdown = FloatingSelectDropdown,
  List = SelectDropdownList,
  activeIndex,
  className = styles.Select,
  contextProps,
  controlProps,
  dropdownProps,
  focusContextProps,
  isOpen,
  listProps,
  options,
  qaName,
  refs,
  tooltip,
  ...restProps
}) {
  const qaPropsSelect = getQaSelector({
    context: QA_NAME_SELECT_CONTEXT,
    value: qaName,
  })

  const qaPropsDropdown = getQaSelector({
    context: QA_NAME_SELECT_DROPDOWN_CONTEXT,
    value: qaName,
  })

  return (
    <SelectContextProvider
      {...contextProps}
      activeIndex={activeIndex}
      isOpen={isOpen}
      qaName={qaName}
    >
      <SelectFocusContextProvider {...focusContextProps}>
        <FloatingTooltip content={tooltip} disabled={!tooltip}>
          <div {...restProps} {...qaPropsSelect} className={className}>
            <Control
              {...controlProps}
              ref={refs?.setReference}
              refs={refs}
              tabIndex={0}
            />

            <Dropdown
              {...dropdownProps}
              {...qaPropsDropdown}
              isOpen={isOpen}
              refs={refs}
            >
              <List {...listProps} options={options} />
            </Dropdown>
          </div>
        </FloatingTooltip>
      </SelectFocusContextProvider>
    </SelectContextProvider>
  )
}

export default Select
